import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import Form from 'react-bootstrap/Form';
import { IUser } from '../../model/user';
import { LabelHeader } from '@yakoffice/shared-components';
import { IamRolesPopOver } from './iam-roles-popover';

interface PropTypes {
    projectId: string;
    user: IUser;
    forceRow?: boolean;
}

export const IamRoles: FC<PropTypes> = observer(({ projectId, user, forceRow }) => {

    const handleSetViewer = () => {
        const isViewer = user.hasIamRoleForProject(projectId, 'viewer');
        user.setIamRoleStatus(projectId, 'viewer', !isViewer);
    };

    const handleSetAdmin = () => {
        const isAdmin = user.hasIamRoleForProject(projectId, 'admin');
        user.setIamRoleStatus(projectId, 'admin', !isAdmin);
    };


    return (
        <div
            className={`${forceRow && 'd-flex flex-row align-items-center justify-items-center align-content-center'}`}>
            {!forceRow && <Form.Label>
                <LabelHeader className="large"><i className={`fas fa-user-shield`} /> Project User
                    Roles <IamRolesPopOver />
                </LabelHeader>
            </Form.Label>}
            <Form className={`${!forceRow ? 'mt-2' : 'ms-1'}`}>
                <Form.Check
                    type="checkbox"
                    id="admin"
                    inline
                    label="User Admin"
                    name="admin"
                    defaultChecked={user.hasIamRoleForProject(projectId, 'admin')}
                    onChange={handleSetAdmin}
                />
                <Form.Check
                    inline
                    type="checkbox"
                    id="viewer"
                    label="User Viewer"
                    name="viewer"
                    defaultChecked={user.hasIamRoleForProject(projectId, 'viewer')}
                    onChange={handleSetViewer}
                />
            </Form>
        </div>
    );
});

